import * as THREE from 'three';

/**
 * A figure standing far down the road against a streetlight's glow, facing her. Just a shape: no face,
 * no detail, gone when she looks away or gets close. Is it him? Someone else?
 * Nobody? The game never says.
 */
export class Apparition {
  readonly group = new THREE.Group();
  // Dark clothes: a silhouette against the lamplight behind it.
  private readonly material = new THREE.MeshStandardMaterial({ color: '#16161a', roughness: 1, metalness: 0 });
  private readonly geometries: THREE.BufferGeometry[] = [];

  constructor() {
    this.group.name = 'apparition';
    const body = new THREE.CapsuleGeometry(0.23, 1.05, 4, 10);
    const head = new THREE.SphereGeometry(0.13, 10, 8);
    const arm = new THREE.CapsuleGeometry(0.06, 0.62, 3, 6);
    this.geometries.push(body, head, arm);
    const add = (g: THREE.BufferGeometry, x: number, y: number, z: number, sx = 1, sz = 1, rz = 0) => {
      const m = new THREE.Mesh(g, this.material);
      m.position.set(x, y, z);
      m.scale.set(sx, 1, sz);
      m.rotation.z = rz;
      this.group.add(m);
    };
    add(body, 0, 0.98, 0, 1.15, 0.7);
    add(head, 0, 1.74, 0.01, 1, 1.1);
    // Arms hanging straight down, a little away from the body.
    add(arm, 0.31, 1.06, 0, 1, 1, 0.06);
    add(arm, -0.31, 1.06, 0, 1, 1, -0.06);
    this.group.visible = false;
  }

  get visible(): boolean {
    return this.group.visible;
  }

  get position(): THREE.Vector3 {
    return this.group.position;
  }

  show(x: number, z: number, face: THREE.Vector3): void {
    this.group.position.set(x, 0, z);
    this.group.rotation.y = Math.atan2(face.x - x, face.z - z);
    this.group.visible = true;
  }

  hide(): void {
    this.group.visible = false;
  }

  dispose(): void {
    for (const g of this.geometries) g.dispose();
    this.material.dispose();
  }
}
